import { NotificationService } from '../../services/notification.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Store } from '../../store';
import { AuthService } from '../../services/auth.service';
import { AlertService } from '../../services/alert.service';
import { Router } from '@angular/router';
import { OverlayService } from '../../services/overlay.service';
import { getSetTimeout$ } from '../../utils/setTimeout$';
import { GoogleAnalyticsService } from '../../modules/tracking/services/google-analytics.service';
import { FacebookPixelService } from '../../modules/tracking/services/facebook-pixel.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    user$ = this.store.select<any>('user');
    basket$ = this.store.select<any>('basket');
    notifications$ = this.store.select<any>('notifications');
    chatStore$ = this.store.select<any>('chatStore');
    settings$ = this.store.select<any>('settings');
    menu$ = this.store.select<any>('menu');
    deviceType$ = this.store.select<string>('deviceType');
    favourites$ = this.store.select<string>('favourites');
    publicTelNo$ = this.store.select<string>('publicTelNo');

    activeMenuImage = '';
    showPromoBar = false;

    confirmationData = {
        open: false,
        title: '',
        detail: '',
        data: undefined,
    };

    closeTimer;

    // Begin Test Code
    @ViewChild('testCodeInput', { static: true }) testCodeInputElement: ElementRef;
    testCode = '';
    // End Test Code

    constructor(
        private store: Store,
        private authService: AuthService,
        private alertService: AlertService,
        private router: Router,
        private overlayService: OverlayService,
        private notificationService: NotificationService,
        private gaService: GoogleAnalyticsService,
        private fbService: FacebookPixelService,
    ) {
    }

    ngOnInit(): void {
        const currentUrl = this.router.url;
        this.showPromoBar = currentUrl === '/';
    }

    toggleUserMenu() {
        this.store.set('mobileMenuUser', true);
    }

    toggleNotifications() {
        this.overlayService.toggle('notifications');
    }

    register() {
        this.store.set('RegisteredInBasketFlow', false);
        // this.router.navigate(['/register']);
        this.overlayService.toggle('registerModal');
    }

    logout() {
        const notifications = { unread: 0, data: [] };
        const chatStore = {
            unread: 0,
            groups: [],
            group: undefined,
            replyingTo: undefined,
            groupToOpen: undefined,
            messages: [],
        };

        this.store.set('chatStore', chatStore);
        this.store.set('notifications', notifications);

        this.notificationService.stopListening();
        this.authService.logout().subscribe(() => {
            this.authService.clearAuthTimeout();
            this.router.navigate(['login']);
        });

    }

    logoutConfirmation() {
        this.confirmationData.title = 'Are you sure you want to logout?';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
    }

    confirmationComplete(e) {
        this.confirmationData.open = false;
        if (e.action) {
            this.logout();
        } else {
        }
    }

    closeSubMenu(menuItem) {
        this.closeTimer = getSetTimeout$(() => {
            this.activeMenuImage = null;
            menuItem.open = false;
        }, 100);
    }

    clickSubMenuParent(menuItem) {
        menuItem.open = false;
        this.router.navigate([menuItem.route]);
    }

    setActiveMenuImage(menuItem, subMenuItem, trigger) {
        if (this.closeTimer) {
            this.closeTimer.unsubscribe();
        }
        if (trigger === 'menuTrigger') {
            const menu = this.store.selectForLocal('menu');

            menu.home.forEach((o) => {
                o.open = false;
            });
            menuItem.open = true;
        }
        if (subMenuItem) {
            if (trigger === 'menuTrigger' && !this.activeMenuImage) {
                this.activeMenuImage = subMenuItem.imageUrl;
            }
            if (trigger === 'optionTrigger' && this.activeMenuImage) {
                this.activeMenuImage = subMenuItem.imageUrl;
            }
        }
    }
}
